import constate from 'constate';
import { useState } from 'react';

import { IInnerStep } from 'core/types';

interface IProps {
  steps: IInnerStep[];
  onClose?: () => void;
}

const useInnerSteps = ({ steps, onClose }: IProps) => {
  const [activeStep, setActiveStep] = useState<IInnerStep>(steps[0]);

  const totalSteps = steps.length;
  const activeStepIndex = steps.findIndex((step) => activeStep?.type === step?.type);

  const goBack = async () => setActiveStep(steps[activeStepIndex - 1]);

  const goNext = async () => {
    const isFinalStep = activeStepIndex === totalSteps - 1;

    if (!isFinalStep) {
      setActiveStep(steps[activeStepIndex + 1]);

      return;
    }

    handleOnClose();
  };

  const handleOnClose = async () => {
    setActiveStep(steps[0]);
    onClose?.();
  };

  return {
    steps,
    activeStep,
    activeStepIndex,
    goBack,
    goNext,
  };
};

export const [InnerStepsProvider, useInnerStepsContext] = constate(useInnerSteps);
